import { LightBulbIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * SV-11: guidance shipped as localised UI rather than the legacy raw .txt file
 * fetched at runtime, so it translates and cannot 404.
 */
export function PromptGuidance() {
  const { t } = useTranslation();

  const tips = t('ai.guidance.tips', { returnObjects: true });
  const items = Array.isArray(tips) ? (tips as string[]) : [];

  return (
    <details className="mt-4 rounded-lg border border-border bg-surface p-4">
      <summary className="flex cursor-pointer items-center gap-2 text-sm font-semibold text-foreground">
        <LightBulbIcon className="size-4 text-accent-foreground" aria-hidden="true" />
        {t('ai.guidance.title')}
      </summary>

      <ul className="mt-3 grid list-disc gap-1.5 pl-5 text-sm text-muted-foreground">
        {items.map((tip) => (
          <li key={tip}>{tip}</li>
        ))}
      </ul>
    </details>
  );
}
